import '../../styles/SingleBadge.css'; // Import the CSS file for styling

const SingleBadge = ({ value, onRemove }) => {
  return (
    <div className="single-badge">
      <div className="badge-content">{value}</div>
      {onRemove && <div className="badge-close" onClick={onRemove}>×</div>}
    </div>
  );
};

export default SingleBadge;